import React from "react";
import { Link } from "react-router-dom"; // For routing

export const Header = ({ data, scrollToSections }) => {
  return (
    <header id="header">
      <div className="intro">
        <div className="overlay">
          <div className="container">
            <div className="row">
              <div className="col-lg-8 col-md-8 col-sm-12 col-xs-12 col-md-offset-2 intro-text">
                <h1>
                  {data ? data.title : "Loading"}
                  <span></span>
                </h1>
                <p>{data ? data.paragraph : "Loading"}</p>
                
                {data && data.logo && (
                  <img 
                    src={data.logo} 
                    alt="Mo2Cloud Logo" 
                    style={{ maxWidth: "160px", margin: "-20px 0 30px 0" }} 
                  />
                )}
                <br></br>
                <Link to="/features" className="btn btn-custom btn-lg page-scroll learn-more-button" onClick={() => scrollToSections('features')}>
                Learn More
              </Link>
                {" "}
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
